module.exports = __webpack_public_path__ + "static/media/main.f430ab9b.jpg";